/* @flow */
import * as Yup from 'yup';
import { intlShape } from 'react-intl';

import { isMembershipOptInCompleted } from '@braindate/domain/lib/membership/util';

import { isMembershipTermsAccepted } from 'src/shared/domain/membership/util/membershipUtil';
import messages from 'src/shared/app/permission/l10n/permissionL10n';

import type { Membership } from '@braindate/domain/lib/membership/type';
import type { CustomOptin } from 'src/shared/app/permission/type/permissionType';

export function isOptinDone(
  membership: Membership,
  areEmailsNotificationsEnabled: boolean,
) {
  return !!(
    isNotificationOptinDone(membership, areEmailsNotificationsEnabled) &&
    isMembershipTermsAccepted(membership)
  );
}

export function isNotificationOptinDone(
  membership: Membership,
  areEmailsNotificationsEnabled: boolean,
) {
  return !!(
    !areEmailsNotificationsEnabled || isMembershipOptInCompleted(membership)
  );
}

export function getCustomOptins(
  customOptins: Array<CustomOptin>,
  intl: intlShape,
) {
  const required = [];
  const notRequired = [];
  const validationShape = {};
  const initialValues = {};

  customOptins.forEach((customOptin) => {
    initialValues[getCustomOptinId(customOptin)] = false;
    if (customOptin.required) {
      validationShape[getCustomOptinId(customOptin)] = Yup.boolean()
        .required(intl.formatMessage(messages.errorRequired))
        .oneOf([true], intl.formatMessage(messages.errorRequired));
      required.push(customOptin);
    } else {
      notRequired.push(customOptin);
    }
  });

  return {
    initialValues,
    required,
    notRequired,
    validationShape,
  };
}

export function getCustomOptinId(customOptin: CustomOptin) {
  return customOptin.label;
}
